<template>
  <div class="message-box-container" :class="{ 'is-visible': isVisible }">
    <div class="message-box">
      <div class="message-header">
        <h3>{{ title }}</h3>
      </div>
      <div class="message-content">
        <div v-if="imageUrl" class="message-image">
          <img :src="imageUrl" alt="步骤示意图" />
        </div>
        <div class="message-text">
          <p>{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose } from "vue";
const isVisible = ref(false);
const title = ref("");
const message = ref("");
const imageUrl = ref("");
const show = (options) => {
  title.value = options.title;
  message.value = options.message;
  imageUrl.value = options.imageUrl || "";
  isVisible.value = true;
};
const hide = () => {
  isVisible.value = false;
};
defineExpose({
  show,
  hide,
});
</script>

<style scoped>
/* 响应式修复：宽度改为30%，并设置500px的最小宽度，同时防止其收缩 */
.message-box-container {
  position: relative;
  width: 30%;
  min-width: 500px;
  height: 96%;
  padding: 0.5rem 0.1rem 0 0;
  box-sizing: border-box;
  z-index: 1000;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  flex-shrink: 0;
}
.message-box-container.is-visible {
  transform: translateX(0);
}
/* 隐藏时占用空间为0，避免影响主区域计算 */
.message-box-container:not(.is-visible) {
  width: 0;
  min-width: 0;
  padding: 0;
  overflow: hidden;
}

.message-box {
  background: white;
  border-radius: var(--border-radius-base);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.message-header {
  color: black;
  border-bottom: 1px solid #e6e9ef;
  padding: 0 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.5rem;
  line-height: 3.5rem;
  flex-shrink: 0;
}
.message-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}
.message-content {
  padding: 0.8rem;
  flex: 1;
  overflow-y: auto;
}
.message-image {
  width: 100%;
  margin-bottom: 1rem;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.message-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
}
.message-text {
  color: #606266;
  line-height: 1.6;
  white-space: pre-wrap;
  font-size: 1rem;
}
.message-text p {
  margin: 0;
}
</style>
